import { ConversationResource } from '@aorg/models/resources/Conversation/ConversationResource';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Conversation } from '../models/conversation';
import type { RootState } from '../store';

const initialState: Conversation = {
  list: [],
  selected: null,
};

const setup = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    setConversationList(
      state,
      { payload }: PayloadAction<ConversationResource[]>
    ) {
      return { ...state, list: payload };
    },
    setConversationSelected(
      state,
      { payload }: PayloadAction<ConversationResource | null>
    ) {
      return { ...state, selected: payload };
    },
    setConversationClear() {
      return initialState;
    },
  },
});

export const {
  setConversationList,
  setConversationSelected,
  setConversationClear,
} = setup.actions;

export const selectConversationList = ({ conversation }: RootState) =>
  conversation.list;
export const selectConversationSelected = ({ conversation }: RootState) =>
  conversation.selected;

export default setup.reducer;
